import toast from "react-hot-toast";

/**
 * attributes array structure, plus optional selectedSize & selectedPack
 */
export const pickSizePackPrice = (attributes, selectedSize = null, selectedPack = null, name) => {
    if (!Array.isArray(attributes)) return null;
    let ref = null;
    let size = selectedSize
    let sizeId = null
    let size_attributeId = null
    let color = []
    //size and pack_per_unit selected hai 

    if (selectedSize) {

        let size_attributes = null

        for (const a of attributes) {

            if (a.size === selectedSize) {
                size_attributes = a?.size_attribute
                sizeId = a?._id
                break
            }

        }

        if (!size_attributes) return null

        if (selectedPack) {

            for (const a of size_attributes) {

                if (a.pack_per_unit_options === selectedPack) {
                    ref = a
                }
            }

            if (!ref) return null
        }
        else {

            for (const a of size_attributes) {

                if (a.is_default) {
                    ref = a
                    color = a?.color
                    size_attributeId = a?._id
                }
            }

            // Wrong: attributes.size_attribute
            if (
                !ref &&
                Array.isArray(size_attributes) &&
                size_attributes.length > 0
            ) {
                ref = size_attributes[0];
                color = size_attributes[0]?.color
                size_attributeId = size_attributes[0]?._id
            }

        }

    }
    else {

        for (const a of attributes) {

            for (const b of a.size_attribute) {

                if (b.is_default) {
                    ref = b
                    size = a?.size
                    sizeId = a?._id
                    size_attributeId = b?._id
                    color = b?.color
                }
            }
        }

        // if (!ref && attributes.length > 0 && attributes.size_attribute.length > 0) {

        //     ref = attributes[0].size_attribute[0]
        //     size = attributes[0].size
        // } 
        if (!ref &&
            Array.isArray(attributes) &&
            attributes.length > 0 &&
            Array.isArray(attributes[0].size_attribute) &&
            attributes[0].size_attribute.length > 0
        ) {

            ref = attributes[0].size_attribute[0]
            size = attributes[0].size
            sizeId = attributes[0]?._id
            size_attributeId = ref?._id
            color = ref?.color
        }
    }

    const retail = Number(ref?.retailPrice) || 0;
    const pct = parseFloat(`${ref?.discount || ''}`.replace('%', '')) || 0;
    const finalPrice = pct
        ? Math.round(retail * (1 - pct / 100) * 100) / 100
        : retail;
    return {
        size,
        pack: ref?.pack_per_unit_options,
        retailPrice: retail,
        discountPercent: pct,
        finalPrice,
        raw: ref,
        sizeId,
        size_attributeId,
        color
    };

}


export const PriceCalculator = (attributes, selectedSize = null, selectedPack = null, name) => {
    if (!Array.isArray(attributes)) return null;
    let ref = null;
    let size = selectedSize
    let sizeId = null
    let size_attributeId = null
    let color = []
    let weight = []
    //size and pack_per_unit selected hai 
    // console.log(selectedPack, selectedSize, size, attributes)

    if (selectedSize) {

        let size_attributes = null

        for (const a of attributes) {

            if (a.size === selectedSize) {
                size_attributes = a?.size_attribute
                sizeId = a?._id

                // break
            }

        }
        if (!size_attributes) return null

        if (selectedPack) {
            // console.log("pack_per_unit_options", selectedPack, size_attributes[0].pack_per_unit_options, size_attributes[0].pack_per_unit_options === selectedPack)
            for (const a of size_attributes) {

                if (a.pack_per_unit_options === selectedPack) {
                    ref = a
                    color = a?.color
                    size_attributeId = a?._id
                }
            }

            if (!ref) return null

        }
        else {

            for (const a of size_attributes) {

                if (a.is_default) {
                    ref = a
                    color = a?.color
                    size_attributeId = a?._id
                    weight = a?.weight
                }
            }

            // Wrong: attributes.size_attribute
            if (
                !ref &&
                Array.isArray(size_attributes) &&
                size_attributes.length > 0
            ) {
                ref = size_attributes[0];
                color = size_attributes[0]?.color
                weight = size_attributes[0]?.weight
                size_attributeId = size_attributes[0]?._id

            }

        }

    }
    else {

        for (const a of attributes) {

            for (const b of a.size_attribute) {

                if (b.is_default) {
                    ref = b
                    size = a?.size
                    sizeId = a?._id
                    size_attributeId = b?._id
                    color = b?.color
                    weight = b?.weight
                }
            }
        }

        // if (!ref && attributes.length > 0 && attributes.size_attribute.length > 0) {

        //     ref = attributes[0].size_attribute[0]
        //     size = attributes[0].size
        // } 
        if (!ref &&
            Array.isArray(attributes) &&
            attributes.length > 0 &&
            Array.isArray(attributes[0].size_attribute) &&
            attributes[0].size_attribute.length > 0
        ) {

            ref = attributes[0].size_attribute[0]
            size = attributes[0].size
            sizeId = attributes[0]?._id
            size_attributeId = ref?._id
            color = ref?.color
            weight = ref?.weight || []

        }
    }

    const retail = Number(ref?.retailPrice) || 0;
    const pct = parseFloat(`${ref?.discount || ''}`.replace('%', '')) || 0;
    const finalPrice = pct
        ? Math.round(retail * (1 - pct / 100) * 100) / 100
        : retail;
    return {
        size,
        pack: ref?.pack_per_unit_options,
        retailPrice: retail,
        discountPercent: pct,
        finalPrice,
        raw: ref,
        sizeId,
        size_attributeId,
        color,
        weight
    };

}


export const colorAndWeightChecker = (product, sizeId, size_attributeId, color, weight) => {

    let sizeAttributeArray = []
    let sizeAttribute = null

    for (let i of (product?.attributes || [])) {
        if (i._id === sizeId) {
            sizeAttributeArray = i?.size_attribute
            break
        }
    }

    if (!sizeAttributeArray.length) {
        toast.error("size doesnot found");
        return false
    }

    for (let i of product?.attributes || []) {
        if (i._id === sizeId) {
            sizeAttributeArray = i?.size_attribute || [];
            break;
        }
    }

    if (!sizeAttribute) {
        toast.error("size_attribute doesnot found");
        return false
    }

    const colorArray = sizeAttribute?.color

    if (Array.isArray(colorArray) && colorArray.length > 0) {
        if (!color) {
            toast.error("Color selection is required for this product variant");
            return false
        }

        if (!colorArray.includes(color)) {
            toast.error("Invalid color selected");
            return false
        }
    } else {
        if (color) {
            toast.error("Color is not required for this product variant, but was provided");
            return false
        }
    }

    const weightArray = sizeAttribute.weight;

    if (Array.isArray(weightArray) && weightArray.length > 0) {
        if (!weight) {
            toast.error("Weight selection is required for this product variant");
            return false
        }

        if (!weightArray.includes(weight)) {
            toast.error("Invalid weight selected");
            return false
        }
    } else {
        if (weight) {
            toast.error("weight is not required for this product variant, but was provided");
            return false
        }
    }

    return true

}